import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { CampaignsManagementContainer } from "./campaigns-style";
import MainTable from "../../../components/main-table";
import CampaignsServices from "../../../services/CampaignsServices";
import { getDayMonthYear } from "../../../utils/time";
import MainButton from "../../../components/main-button";
import { images } from "../../../assets";

interface CampaignsProps extends RouteComponentProps {
  setLoading: Function;
}

interface CampaignsState {
  selectedTag: number;
  currentCampaigns: any[];
  expiredCampaigns: any[];
  isLoading: boolean;
  isError: boolean;
}

const COLUMNS_CAMPAIGNS = [
  {
    text: "código",
    filter: false,
    ascendent: true,
  },
  {
    text: "nombre",
    filter: false,
    ascendent: true,
  },
  {
    text: "obligatorio",
    filter: false,
    ascendent: true,
    key: 'inline',
  },
  {
    text: "colectivo",
    filter: false,
    ascendent: false,
    key: 'inline',
  },
  {
    text: "combinación comercial",
    filter: false,
    ascendent: true,
    key: 'inline',
  },
  {
    text: "fechas vigencia",
    filter: false,
    ascendent: true,
    key: 'inline',
  },
  {
    text: "fechas efecto",
    filter: false,
    ascendent: true,
    key: 'inline',
  }
];

class CampaignsManagement extends React.Component<CampaignsProps, CampaignsState> {
  constructor(props: CampaignsProps) {
    super(props);
    this.state = {
      selectedTag: 0,
      currentCampaigns: [],
      expiredCampaigns: [],
      isLoading: true,
      isError: false
    };
  }

  async componentDidMount() {
    await this.getAllCampaigns();
  }

  getAllCampaigns = async () => {
    try {
      const { setLoading } = this.props;
      const allCampaigns = await CampaignsServices.getAllCampaigns({
        loader: true,
        setLoading,
      })
      .then((data) => { return data })
      .catch(() => { this.setState({ isError: true}) });;

      const currentCampaigns = this.campaignsToRows(this.getCurrentCampaigns(allCampaigns));
      const expiredCampaigns = this.campaignsToRows(this.getExpiredCampaigns(allCampaigns));
  
      this.setState({ currentCampaigns, expiredCampaigns, isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  getCurrentCampaigns = (campaigns: any []) => {
    const noExpiration = new Date();
    return campaigns.filter((c) => new Date(c.endDate) > noExpiration && new Date(c.startDate) < noExpiration);
  }

  getExpiredCampaigns = (campaigns: any []) => {
    const noExpiration = new Date();
    return campaigns.filter((c) => new Date(c.endDate) < noExpiration || new Date(c.startDate) > noExpiration);
  }

  campaignsToRows(campaigns: any []){
    return campaigns.map((c : any) => {
      return {
        code: {
          text: c.code,
          type: "",
          key: "inline",
        },
        name: {
          text: c.name,
          type: "",
          key: "inline",
        },
        isRequired: {
          text: c.isRequired ? "SI" : "NO",
          type: "",
          key: "inline",
        },
        colectivo: {
          text: c.colectivo,
          type: "",
          key: "inline",
        },
        combinacion_comercial: {
          text: c.combinacion_comercial,
          type: "",
          key: "inline",
        },
        date: {
          text: `${getDayMonthYear(c.startDate)} - ${getDayMonthYear(c.endDate)}`,
          type: "",
          key: "inline",
        },
        effectDate: {
          text: `${getDayMonthYear(c.startEffectDate)} - ${getDayMonthYear(c.endEffectDate)}`,
          type: "",
          key: "inline",
        }
      }
    })
  }

  handleChangeTab = (tag: number) => this.setState({ selectedTag: tag });
  

  render() {
    const { selectedTag, currentCampaigns, expiredCampaigns, isLoading, isError } = this.state;

    return (
      <CampaignsManagementContainer>
        <div className="main-title-container-complex">
          <div className="main-title-container-complex-item col-6">
            <h2 className="campaings-title">Gestión de Campañas</h2>
          </div>
          <div className="col-6">
            <MainButton text="REGISTRAR CAMPAÑA" onClick={() =>  this.props.history.push("/gestor-campañas/nueva") } />
          </div>
        </div>

        <div className="main-filter-container">
          <div className="tabs-container">
            <div className="tabs-container__tabs">
              <div className={selectedTag === 0 ? "selected" : ""} onClick={() => this.handleChangeTab(0)}>
                Campañas Vigentes
              </div>
              <div className={selectedTag === 1 ? "selected" : ""} onClick={() => this.handleChangeTab(1)}>
                Campañas Expiradas
              </div>
            </div>
            <div className={`tabs-container__line ${selectedTag === 0 ? "selected-right" : ""}`}/>
          </div>

          <div className="topMargin40">
            { !isLoading && !isError &&
              <>
                { ((selectedTag === 0 && currentCampaigns.length > 0) || (selectedTag === 1 && expiredCampaigns.length > 0 ))  &&
                  <MainTable
                    className="table"
                    columns={COLUMNS_CAMPAIGNS}
                    rows={selectedTag === 0 ? currentCampaigns : expiredCampaigns}
                    keysRow={["code", "name", "isRequired", "colectivo", "combinacion_comercial", "date", "effectDate"]}
                    rowLink={"/gestor-campañas/editar"}
                    rowKeyLink={"code"}
                  />
                }
                { selectedTag === 0 && currentCampaigns.length === 0 && <p>No existen campañas vigentes.</p> }
                { selectedTag === 1 && expiredCampaigns.length === 0 && <p>No existen campañas expiradas.</p> }
              </>
            }
            { isError && <p>No se han recuperado las campañas, por favor, recargue la página.</p>}
          </div>  
        </div>
      </CampaignsManagementContainer>
    );
  }
}

export default withRouter(CampaignsManagement);
